
import { DictionaryContent } from "../../components/dictionary";


export default function Dictionary () {

  return (
    <>
      <DictionaryContent/>
    </>
  )

}